var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5216 9.57658L8.94504 6.08258L12.439 2.506",
    stroke: "#41464B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5626 5.80555C10.6755 5.42311 11.8628 5.30792 13.0284 5.46928C14.1941 5.63065 15.3054 6.06404 16.2726 6.73442C17.2397 7.40481 18.0356 8.29336 18.5957 9.32826C19.1559 10.3632 19.4647 11.5153 19.4971 12.6917C19.5296 13.868 19.2848 15.0355 18.7825 16.0996C18.2802 17.1638 17.5346 18.0949 16.6058 18.8176C15.6771 19.5403 14.5913 20.0342 13.4363 20.2596C12.2814 20.485 11.0895 20.4354 9.95725 20.1149",
    stroke: "#41464B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 6.36396,
    height: 6.36396,
    rx: 1,
    transform: "rotate(45 6 9)",
    stroke: "#41464B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotate);
export default __webpack_public_path__ + "static/media/icon_rotate.f79df726e89525f9fc09e28a99aee82d.svg";
export { ForwardRef as ReactComponent };